<template>
  <component
    :is="scroll ? 'v-slide-group' : 'div'"
    show-arrows
    :class="{
      'd-flex ga-4 flex-wrap justify-center': !scroll
    }"
  >
    <component
      :is="scroll ? 'v-slide-group-item' : 'div'"
      v-for="user in users"
      :key="user.id"
    >
      <div>
        <v-card
          class="pa-4 user-card flex-shrink-0"
          :class="{
            active: selectedId == user.id
          }"
          rounded="lg"
          @click="selectedId = user.id"
          elevation="0"
          :disabled="disabled"
        >
          <profile-image
            :user="user"
            size="70"
            :bordered="selectedId == user.id"
            class="mb-4 mx-auto"
          />

          <div
            class="user-name"
            v-if="user.first_name && user.last_name"
          >
            {{ user.name_abbr }}
          </div>
          <div
            class="user-name opacity-60"
            v-else
          >
            Name not set.
          </div>
        </v-card>

        <v-icon
          v-if="showImpersonate && $auth.user!.id !== user.id && $auth.user!.can_impersonate && user.can_user_be_impersonated"
          v-tooltip:bottom="'Impersonate ' + user.name_abbr"
          class="mt-4"
          color="#CCCCCC"
          @click="impersonateUser(user)"
        >
          social_distance
        </v-icon>
      </div>
    </component>
  </component>
</template>
<script lang="ts">
import type {PropType} from "vue"
import ProfileImage from "@/components/ProfileImage.vue"
import {VSlideGroup, VSlideGroupItem} from "vuetify/components/VSlideGroup"

export default {
  name: 'UserSelector',
  components: {ProfileImage, VSlideGroup, VSlideGroupItem},
  props: {
    modelValue: {
      type: Number as PropType<number | null>,
      default: null,
    },
    users: {
      type: Array as PropType<App.Models.User[]>,
      required: true
    },
    disabled: Boolean,
    scroll: Boolean,
    showImpersonate: Boolean,
  },
  emits: ['update:modelValue'],
  computed: {
    selectedId: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    async impersonateUser(user: App.Models.User) {
      if (!(await this.$confirm(
        'Impersonate',
        `Are you sure you want to impersonate ${user.name_abbr}?`,
        {
          showCancel: true,
        }
      ))) return
      const {data: {errors}, status} = await this.$auth.impersonate(user.id)
      if (this.$error(status, 'Error Impersonating', errors)) return

      location.reload()
    }
  },
}
</script>

<style lang="scss" scoped>
.v-slide-group {
  max-width: min(480px, 80vw);
}
:deep() {
  .v-slide-group__content {
    gap: 15px;
  }
  .v-slide-group__prev, .v-slide-group__next {
    min-width: 40px;
    &--disabled {
      color: #0000;
    }
  }
}

.user-card {
  width: 120px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: rgb(var(--v-theme-accent));

  .user-name {
    font-size: 15px;
    text-align: center;
  }

  &.active {
    background-color: rgb(var(--v-theme-primary));

    .user-name {
      color: white;
    }
  }
}
</style>
